import { initializeApp } from "firebase/app";
import {
  getToken,
  getMessaging,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDGe-26-XTmA12o8v_fBz1-PmEhAvpRbx8",
  authDomain: "touramp-375aa.firebaseapp.com",
  databaseURL: "https://touramp-375aa-default-rtdb.firebaseio.com",
  projectId: "touramp-375aa",
  storageBucket: "touramp-375aa.appspot.com",
  messagingSenderId: "719169076753",
  appId: "1:719169076753:web:562476c0cf25d17ecdfbb0",
  measurementId: "G-L3DHBZNR1D",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
// export const messaging = getMessaging(firebaseApp);

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(firebaseApp);
    }
    console.log("Firebase is not supported in this browser");
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();

// getOrRegisterServiceWorker function is used to try and get the service worker if it exists, otherwise it will register a new one.
export const getOrRegisterServiceWorker = async () => {
  if (
    !("serviceWorker" in navigator) ||
    typeof window.navigator.serviceWorker === "undefined" ||
    !("PushManager" in window)
  ) {
    return null;
  }
  try {
    const existing = await window.navigator.serviceWorker.getRegistration(
      "/firebase-push-notification-scope"
    );
    if (existing) return existing;
    return await window.navigator.serviceWorker.register(
      "/firebase-messaging-sw.js",
      {
        scope: "/firebase-push-notification-scope",
      }
    );
  } catch (err) {
    console.warn("Push service worker unavailable:", err);
    return null;
  }
};

// getFirebaseToken function generates the FCM token
export const getFirebaseToken = async (): Promise<string | undefined> => {
  try {
    if (!("PushManager" in window)) return undefined;

    const messagingResolve = await messaging;
    if (!messagingResolve) return undefined;

    const serviceWorkerRegistration = await getOrRegisterServiceWorker();
    if (!serviceWorkerRegistration) return undefined;

    return await getToken(messagingResolve, {
      vapidKey: `BPFFmP-ie183iJsxhCJ5kRYgQXfRjd3Ri9pXRsNwcVDGUW351b-V2HbM8OdoI7gNpzw0nDXDmhnqoblrANm0HjM`,
      serviceWorkerRegistration,
    });
  } catch (error) {
    // Localhost / unsupported push is expected — do not surface as uncaught
    console.warn("Firebase push token unavailable:", error);
    return undefined;
  }
};

// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       console.log("payload", payload);
//       resolve(payload);
//     });
//   });

export const onMessageListener = async () => {
  try {
    const messagingResolve = await messaging;
    if (!messagingResolve) return null;

    return new Promise((resolve) => {
      onMessage(messagingResolve, (payload) => {
        console.log("payload", payload);
        resolve(payload);
      });
    });
  } catch (error) {
    console.warn("Firebase onMessage listener unavailable:", error);
    return null;
  }
};
